import React from "react";
import "../App.css";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { DownloadDocument } from "../Actions/CommonAPI";
import userRoles from '../helpers/role';
import Moment from 'moment';
import { getPendingTask, getSixMonthReview, getSixMonthReviews } from "../Actions/ShipViewAPI";
import * as moment from 'moment';
import AddIcon from "../UIComponents/AddIcon";

class SixMonthReview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            shipId: '',
            currentPage: 0
        };
        this.onPaginatorChange = this.onPaginatorChange.bind(this);
    }

    componentDidMount() {
        this.props.dispatch({ type: "ShowSidePan", data: false });
        const { dispatch, match } = this.props;
        if (match.params.id) {
            this.state.shipId = match.params.id;
            dispatch(getSixMonthReviews(this.state.shipId));
        }
    }

    renderPopover(props) {
        return (
            <Popover id="history-tooltip" {...props}>
                <Popover.Content>
                    <label>Download Last Service Report</label>
                </Popover.Content>
            </Popover>
        );
    }
    updatePopover(props) {
        return (
            <Popover id="history-tooltip" {...props}>
                <Popover.Content>
                    <label>Update</label>
                </Popover.Content>
            </Popover>
        );
    }
    showEditPODetailPanel = (item) => {
        const { history } = this.props;
        if (window.location.href.indexOf("/Home/Ship/Staff/Tasks") !== -1) {
            //  this.props.dispatch({ type: "TaskDetails", data: item });
            // this.props.history.push(`/Home/Ship/Staff/Tasks/POUpdate`);
            this.props.history.push(`/Home/Staff/POValidation/${item.shipId}/${item.purchaseOrderId}`);
            window.scrollTo(0, 0);
        }
    }

    showPODetailPanel = (shipId, poId) => {
        const { history, dispatch } = this.props;
        dispatch({ type: "POView", data: false });
        dispatch({ type: "EditPOView", data: false });
        history.push(`/Home/POView/${shipId}/${poId}`);
    };

    getPoInfo = (item) => {
        const { dispatch } = this.props;
        this.setState({ modalIsOpen: true })
    }

    NewitemNav = () => {
        const { dispatch, match } = this.props;
        if (match.params.id) {
            this.props.history.push(`/Home/Ship/${match.params.id}/SixMonthReviewEdit`);
            this.props.dispatch({ type: "ShowSidePan", data: false });
        }
    };

    render() {
        const { pendingTasks, currentRole } = this.props;
        return (
            <div className="pb-4">
                <div className="row mt-2">
                    <div className="col-lg-12">
                        <div className="card mt-2 MM-card-header mb-1">
                            <div className="card-body flex" style={{ padding: "0rem", backgroundColor: "#1E3A8A", color: "white" }}>
                                <h5 className="card-title m-2" style={{ color: "092a51" }}>IHM Review</h5>
                                <div className="m-1 flex" onClick={this.NewitemNav}>
                                    <span className="card-title m-auto">Add</span><AddIcon />
                                </div>
                            </div>
                        </div>
                        <div className="p-0">
                            <div className="row">
                                <div className="col-sm-12">
                                    {this.renderCardPendingData()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* {sixMonthReviews && sixMonthReviews.length ? (
                    <Paginator
                        first={this.state.currentPage}
                        rows={pendingTasks.pagination.pageSize}
                        totalRecords={pendingTasks.pagination.totalcount ? pendingTasks.pagination.totalcount : 0}
                        onPageChange={(e) => this.onPaginatorChange(e)}>
                    </Paginator>
                ) : (
                        <div className="card" style={{ overflow: "hidden", position: "relative" }}>
                            <div class="container">
                                <h6 className="resource-list-title no-item-card">
                                    No Tasks
                </h6>
                            </div>
                        </div>
                    )} */}
            </div>
        );
    }

    onPaginatorChange(event) {
        const { staffShipId, dispatch } = this.props;
        this.setState({ currentPage: event.first, });
        dispatch(getPendingTask(staffShipId, event.page + 1));
    }

    renderCardPendingData = () => {
        const { showSidePane, currentRole, sixMonthReviews } = this.props;
        return sixMonthReviews && sixMonthReviews.length
            ? sixMonthReviews.map((item, index) => {
                return (
                    <div className="card" style={{ overflow: "hidden", position: "relative", marginBottom: '5px' }}>
                        <div className="px-3 py-2">
                            <div className="resource-list-auth-date">
                                <div className="row mx-0">
                                    <div className={showSidePane ? "col-sm-10 col-md-11 col-10 col-m-auto" : "col-sm-10 col-md-11 col-10 col-m-auto"}>
                                        <div className="row">
                                            <div className={showSidePane ? "col-sm-6" : "col-sm-6"}>
                                                <span>
                                                    <strong>Ship Name : </strong>
                                                    <span className="italicFont">{item.shipName}</span>
                                                </span>
                                            </div>
                                            <div className={showSidePane ? "col-sm-6" : "col-sm-6"}>
                                                <span>
                                                    <strong>Date of Revision : </strong>
                                                    <span className="italicFont">{moment(item.dateOfRevision).format("DD MMM YYYY")}</span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-sm-2 col-md-1 col-2 col-m-auto text-right">
                                        <i className="fa fa-eye click" aria-hidden="true" style={{ color: " #1E3A8A", fontSize: '30px' }}
                                            onClick={() => this.showSidePanel(item.revisionBySixMonthId)}
                                        >
                                        </i>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }) :
            <div
                className="card"
                style={{ overflow: "hidden", position: "relative" }}
            >
                <div class="container">
                    <h6 className="resource-list-title no-item-card">
                        No Reviews to Display
              </h6>
                </div>
            </div>;
    };
    downloadAttachment = (FileName, Guid) => {
        const { dispatch } = this.props;
        dispatch(DownloadDocument(FileName, Guid));
    }
    showSidePanel = (id) => {
        const { dispatch, match } = this.props;
        if (match.params.id) {
            let shipId = match.params.id;
            this.props.dispatch({ type: "ShowSidePan", data: true });
            this.props.history.push(`/Home/Ship/${shipId}/SixMonthReview/${id}`);
            dispatch(getSixMonthReview(id));
        }
    };


}

function mapStateToProps(state) {
    return {
        //BY BALU MOORTHI
        sixMonthReviews: state.ShipViewReducer.SixMonthReviews || [],
        showSidePane: state.SidePanReducer.sidePan || false,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(SixMonthReview)
);
